import { gql } from '@apollo/client';

export const UPDATE_MAP_SESSION = gql`
  mutation UpdateMapSession($input: MapSessionUpdateInput!) {
    mapSessionUpdate(input: $input) {
      id
      userId
      hasCompletedOnboarding
      hasCompletedOnboardingPlanView
      mapData
      lastViewed
      createdAt
      updatedAt
    }
  }
`;
